module.exports = __webpack_public_path__ + "static/media/close.45a720d3.svg";